import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-tryout-past-due-members',
  templateUrl: './tryout-past-due-members.component.html',
  styleUrls: ['./tryout-past-due-members.component.css']
})
export class TryoutPastDueMembersComponent implements OnInit {

  @Input() NoOfPastDueMembers: string;
  @Output() filterMembersEvent = new EventEmitter();

  program_status = '';

  constructor() { }

  ngOnInit() {
  }

  filterMemberListing(value) {
    this.program_status = value;
    this.filterMembersEvent.emit(this.program_status);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/components/tryout-past-due-members/tryout-past-due-members.component.ts